import {matchPath} from 'react-router-dom';
import {auth, supportCentreCollectionUrl, supportCentreArticleUrl} from 'main/tools';

const PATH_CONTENT = {
  '/time_off': {
    collectionId: '227959',
    articles: [
      {
        id: '12691625',
        titleKey: 'components.support_centre.articles.How to Create a Time Off Policy',
        featurePermissions: ['::MANAGE_TIME_OFF']
      },
      {
        id: '2133205',
        titleKey: 'components.support_centre.articles.Updating a Time Off Policy',
        featurePermissions: ['::MANAGE_TIME_OFF']
      },
      {
        id: '2714437',
        titleKey: 'components.support_centre.articles.Changing an Employee\'s Time Off Policy',
        featurePermissions: ['::MANAGE_TIME_OFF']
      },
      {
        id: '12590585',
        titleKey: 'components.support_centre.articles.Create a New Time Off Type',
        featurePermissions: ['::MANAGE_TIME_OFF']
      },
      {
        id: '1027673',
        titleKey: 'components.support_centre.articles.Adding Company Holidays',
        featurePermissions: ['::MANAGE_TIME_OFF']
      },
      {
        id: '10486648',
        titleKey: 'components.support_centre.articles.How to Approve Time Off'
      }
    ]
  },
  '/time_tracking': {
    collectionId: '9895327',
    articles: [
      {
        id: '9623736',
        titleKey: 'components.support_centre.articles.How to Use Time Tracking',
        featurePermissions: ['::MANAGE_TIME_TRACKING']
      },
      {
        id: '17826944',
        titleKey: 'components.support_centre.articles.Shift Scheduling'
      },
      {
        id: '9612600',
        titleKey: 'components.support_centre.articles.Provincial Overtime Guidelines'
      }
    ]
  },
  '/offers': {
    collectionId: '3450805',
    articles: [
      {
        id: '6051128',
        titleKey: 'components.support_centre.articles.How to Create and Send Offers'
      }
    ]
  },
  '/surveys': {
    collectionId: '2177712',
    articles: [
      {
        id: '2952881',
        titleKey: 'components.support_centre.articles.How to Create Surveys',
        featurePermissions: ['::MANAGE_SURVEYS']
      },
      {
        id: '5786313',
        titleKey: 'components.support_centre.articles.Survey Reports',
        featurePermissions: ['::MANAGE_SURVEYS']
      }
    ]
  },
  '/training': {
    collectionId: '228084',
    articles: [
      {
        id: '1567568',
        titleKey: 'components.support_centre.articles.Creating and Managing Training Programs',
        featurePermissions: ['::MANAGE_TRAINING']
      },
      {
        id: '4880150',
        titleKey: 'components.support_centre.articles.Training Quizzes',
        featurePermissions: ['::MANAGE_TRAINING']
      }
    ]
  },
  '/mass_updates': {
    collectionId: '3857404',
    articles: [
      {
        id: '6916476',
        titleKey: 'components.support_centre.articles.How to Use Mass Updates'
      }
    ]
  },
  '/performance': {
    collectionId: '227968',
    articles: [
      {
        id: '699540',
        titleKey: 'components.support_centre.articles.Creating a Performance Check-In Cycle',
        featurePermissions: ['::MANAGE_PERFORMANCE_MANAGEMENT']
      },
      {
        id: '701983',
        titleKey: 'components.support_centre.articles.Complete a Performance Check-In as a Manager'
      }
    ]
  },
  '/goals': {
    collectionId: '1821363',
    articles: [
      {
        id: '9298666',
        titleKey: 'components.support_centre.articles.Creating and Using Goals'
      }
    ]
  },
  '/recruiting': {
    collectionId: '227913',
    articles: [
      {
        id: '1541349',
        titleKey: 'components.support_centre.articles.Creating a New Job Position',
        featurePermissions: ['::MANAGE_ATS']
      },
      {
        id: '1392754',
        titleKey: 'components.support_centre.articles.Creating Your Own Careers Page',
        featurePermissions: ['::MANAGE_ATS']
      },
      {
        id: '6772768',
        titleKey: 'components.support_centre.articles.Interview Guides',
        featurePermissions: ['::MANAGE_ATS']
      },
      {
        id: '1568979',
        titleKey: 'components.support_centre.articles.Integrating Jobs on Your Website',
        featurePermissions: ['::MANAGE_ATS']
      },
      {
        id: '1537332',
        titleKey: 'components.support_centre.articles.Emailing Job Candidates'
      },
      {
        id: '1539692',
        titleKey: 'components.support_centre.articles.Creating Email Templates for Your Recruiting Process',
        featurePermissions: ['::MANAGE_ATS']
      },
      {
        id: '15649335',
        titleKey: 'components.support_centre.articles.Inviting Candidates to Book an Interview'
      }
    ]
  },
  '/payroll': {
    collectionId: '18044734',
    articles: [
      {
        id: '14037050',
        titleKey: 'components.support_centre.articles.Collage Payroll: Quick Launch Guide'
      },
      {
        id: '14126043',
        titleKey: 'components.support_centre.articles.Payroll Items and Presets'
      },
      {
        id: '14127163',
        titleKey: 'components.support_centre.articles.Accounting Codes and Integrations'
      },
      {
        id: '13577373',
        titleKey: 'components.support_centre.articles.Adding a Contractor to Collage Payroll'
      },
      {
        id: '14037506',
        titleKey: 'components.support_centre.articles.Creating a Record of Employment (ROE)'
      },
      {
        id: '14485142',
        titleKey: 'components.support_centre.articles.Making a Correction on an Approved Payroll'
      }
    ]
  },
  '/benefits/benefit_enrolments': {
    collectionId: '3817669',
    articles: [
      {
        id: '12258236',
        titleKey: 'components.support_centre.articles.Enrolment in Benefits - New Hire'
      },
      {
        id: '4677488',
        titleKey: 'components.support_centre.articles.Benefit Info Update Statuses'
      },
      {
        id: '12305633',
        titleKey: 'components.support_centre.articles.Benefits: Plan Administrator Handbook'
      },
      {
        id: '10486130',
        titleKey: 'components.support_centre.articles.How to Give Benefits Access to Your Advisor'
      },
      {
        id: '10485400',
        titleKey: 'components.support_centre.articles.How to Change Benefits Providers'
      }
    ]
  },
  '/company_settings/calendars': {
    articles: [
      {
        id: '2305875',
        titleKey: 'components.support_centre.articles.How to Use Custom Calendars'
      }
    ]
  },
  '/company_settings/documents': {
    collectionId: '1553007',
    articles: [
      {
        id: '1336094',
        titleKey: 'components.support_centre.articles.Starting with Your Company Documents'
      },
      {
        id: '1343321',
        titleKey: 'components.support_centre.articles.Sharing Documents with Your Existing Employees'
      },
      {
        id: '1350997',
        titleKey: 'components.support_centre.articles.Sharing Documents with Your New Hires'
      },
      {
        id: '12582104',
        titleKey: 'components.support_centre.articles.Upload Employee Documents'
      },
      {
        id: '2672917',
        titleKey: 'components.support_centre.articles.Annotating PDF Documents'
      },
      {
        id: '2673406',
        titleKey: 'components.support_centre.articles.Document Folders',
        featurePermissions: ['::MANAGE_FOLDERS']
      }
    ]
  },
  '/company_settings/permissions': {
    collectionId: '228005',
    articles: [
      {
        id: '836928',
        titleKey: 'components.support_centre.articles.Roles & Permissions Overview'
      },
      {
        id: '1045979',
        titleKey: 'components.support_centre.articles.How to Create a Custom Role'
      },
      {
        id: '1042216',
        titleKey: 'components.support_centre.articles.Default Role: Super Admin'
      },
      {
        id: '1042218',
        titleKey: 'components.support_centre.articles.Default Role: Manager'
      },
      {
        id: '2501763',
        titleKey: 'components.support_centre.articles.Managing Admin Access'
      }
    ]
  },
  '/expenses': {
    articles: [
      {
        id: '14967492',
        titleKey: 'components.support_centre.articles.Getting Started with Expenses',
        featurePermissions: ['::MANAGE_EXPENSES']
      }
    ]
  },
  '/reports': {
    collectionId: '227906',
    articles: [
      {
        id: '1906727',
        titleKey: 'components.support_centre.articles.Creating Custom Reports',
        featurePermissions: ['::CUSTOM_REPORT']
      },
      {
        id: '510636',
        titleKey: 'components.support_centre.articles.Active Employees Report',
        featurePermissions: ['::ACTIVE_EMPLOYEES_REPORT']
      },
      {
        id: '510681',
        titleKey: 'components.support_centre.articles.New Hires and Terminations Report',
        featurePermissions: ['::NEW_HIRES_AND_TERMINATIONS_REPORT']
      },
      {
        id: '510730',
        titleKey: 'components.support_centre.articles.Time Off Balances Report',
        featurePermissions: ['::TIME_OFF_BALANCES_REPORT']
      },
      {
        id: '510838',
        titleKey: 'components.support_centre.articles.Time Off Requests Report',
        featurePermissions: ['::TIME_OFF_REQUESTS_REPORT']
      },
      {
        id: '16150208',
        titleKey: 'components.support_centre.articles.Time Off Liability Report',
        featurePermissions: ['::VACATION_LIABILITY_REPORT']
      },
      {
        id: '836844',
        titleKey: 'components.support_centre.articles.Time Off Payroll Reconciliation Report',
        featurePermissions: ['::PAYROLL_RECONCILIATION_REPORT']
      }
    ]
  },
  '/reviews': {
    collectionId: '228100',
    articles: [
      {
        id: '1967931',
        titleKey: 'components.support_centre.articles.Creating a Performance Review',
        featurePermissions: ['::MANAGE_PERFORMANCE_MANAGEMENT']
      },
      {
        id: '1967932',
        titleKey: 'components.support_centre.articles.Creating a Question Set',
        featurePermissions: ['::MANAGE_PERFORMANCE_MANAGEMENT']
      },
      {
        id: '1976267',
        titleKey: 'components.support_centre.articles.Launching and Completing Performance Reviews',
        featurePermissions: ['::MANAGE_PERFORMANCE_MANAGEMENT']
      },
      {
        id: '1976341',
        titleKey: 'components.support_centre.articles.Closing and Sharing Performance Reviews',
        featurePermissions: ['::MANAGE_PERFORMANCE_MANAGEMENT']
      },
      {
        id: '2020800',
        titleKey: 'components.support_centre.articles.Completing a Self-Review: What to Expect'
      },
      {
        id: '2020844',
        titleKey: 'components.support_centre.articles.Completing a Manager Review: What to Expect'
      }
    ]
  }
};

export function supportCentreContentFor(path) {
  const mostSpecificMatchedPath = Object.keys(PATH_CONTENT).filter(
    (matcher) => matchPath(path, {path: matcher})
  ).sort((a, b) => a.length - b.length).pop();

  let {collectionId = null, articles = []} = PATH_CONTENT[mostSpecificMatchedPath] || {};

  return {
    collectionUrl: supportCentreCollectionUrl(collectionId),
    articles: articles.filter(articleVisibleToCurrentUser).map(article => ({
      ...article,
      url: supportCentreArticleUrl(article.id)
    }))
  };
}

function articleVisibleToCurrentUser({featurePermissions = []}) {
  return featurePermissions.every(permission => auth.hasAccess(permission));
}
